import { ProductAddedModal } from "@modules/Navbar/components/ProductAddedModal";
import { useCart } from "@shopify/hydrogen-react";
import { AnimatePresence } from "framer-motion";
import { useLocation } from "@tanstack/react-router";
import { useCallback, useEffect, useState } from "react";

type Props = {
  closeModal: () => void;
  cancelClosing: () => void;
};

export const ProductAddedDisplay: React.FC<Props> = ({
  closeModal,
  cancelClosing,
}) => {
  const { pathname } = useLocation();
  const { totalQuantity } = useCart();
  const [displayCartItemAdded, setDisplayCartItemAdded] = useState(false);

  // Derive "segment" from pathname (e.g. /hr/cart -> "cart")
  const segments = pathname.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1];

  const handleShowModal = useCallback(() => {
    setDisplayCartItemAdded(true);
  }, []);
  const handleCloseModal = useCallback(() => {
    setDisplayCartItemAdded(false);
  }, []);

  useEffect(() => {
    addEventListener("cart:lineItemAdded", handleShowModal);
    addEventListener("cart:modalClose", handleCloseModal);
    return () => {
      removeEventListener("cart:lineItemAdded", handleShowModal);
      removeEventListener("cart:modalClose", handleCloseModal);
    };
  }, [handleCloseModal, handleShowModal]);

  // Reset display when cart becomes empty (sync during render, not in effect)
  const [prevTotalQuantity, setPrevTotalQuantity] = useState(totalQuantity);
  if (prevTotalQuantity !== totalQuantity) {
    setPrevTotalQuantity(totalQuantity);
    if (totalQuantity === 0) {
      setDisplayCartItemAdded(false);
    }
  }

  if (lastSegment === "cart") {
    closeModal();
    return null;
  }

  return (
    <AnimatePresence>
      {displayCartItemAdded ? (
        <ProductAddedModal
          closeModal={closeModal}
          cancelClosing={cancelClosing}
        />
      ) : null}
    </AnimatePresence>
  );
};
